<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>

            <slot/>

          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>

<!--  <div>-->
<!--    <h2>Parent</h2>-->
<!--    <slot/>-->
<!--    <h2>Parent</h2>-->
<!--  </div>-->

</template>

<script>
  export default {
    name: "LoginLayout"
  }
</script>



// WEBPACK FOOTER //
// src/appLayouts/LoginLayout.vue